import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'numberToTimeLISTA'
})
export class NumberToTimePipeLISTA implements PipeTransform {

  transform(valorInicial: number): string {

    var hora = valorInicial / 60;
    var minutos = valorInicial % 60;
    var horaSinDecimal = Math.trunc(hora);
    var minutosSinDecimal = Math.trunc(minutos);

    var cadenaHora: string = (horaSinDecimal < 10) ? "0" + horaSinDecimal.toString() : horaSinDecimal.toString();
    var minutoHora: string = (minutosSinDecimal < 10) ? "0" + minutosSinDecimal.toString() : minutosSinDecimal.toString();

    return `${cadenaHora}:${minutoHora}:00`
  }

}
